import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const AffiliatePayments = () => {
  const getAll = params =>
    AuthAxios.get(`${DataApiUrl}/admin/affiliatePayments`, params)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getTotalPayable = () =>
    AuthAxios.get(`${DataApiUrl}/admin/affiliatePayments/totalPayable`)
      .then(res => res.data.data.results)
      .catch(err => {
        throw err.response;
      });

  const queueCloseAllPayableReferrals = () =>
    AuthAxios.post(`${DataApiUrl}/admin/affiliatePayments/queue-close-all-payable-referrals`).then(
      res => res.data.data
    );

  return {
    getAll,
    getTotalPayable,
    queueCloseAllPayableReferrals,
  };
};

export default AffiliatePayments;
